import { render } from "./PaymentDialog.vue?vue&type=template&id=b4501f6a"
import script from "./PaymentDialog.vue?vue&type=script&lang=js"
export * from "./PaymentDialog.vue?vue&type=script&lang=js"

import "./PaymentDialog.vue?vue&type=style&index=0&id=b4501f6a&lang=scss"
script.render = render

export default script